import { Link } from 'react-router-dom';
import logoBar from '../assets/logo-bar.png';
import logoBarLight from '../assets/logo-bar-light.png';
import icon128 from '../assets/icon128.png';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'horizontal' | 'icon';
  linkTo?: string;
}

// `sm` is the TopBar lockup shown on every page; `lg` is the login/auth hero.
const HEIGHTS = { sm: 30, md: 32, lg: 48 };

export function Logo({ size = 'md', variant = 'horizontal', linkTo }: LogoProps) {
  const h = HEIGHTS[size];

  // The icon (mark) is the same in both themes — colorful on transparent, reads
  // on light or dark. Only the horizontal lockup needs a light-mode swap, since
  // its "riff" wordmark is near-white (invisible on a light background). We ship
  // both lockups and let CSS show the right one for the active theme, so the
  // logo flips the instant the global theme toggle changes [data-theme].
  let inner;
  if (variant === 'icon') {
    inner = (
      <img className="rl-logo-img" src={icon128} alt="Riffloop" style={{ height: h, width: 'auto' }} />
    );
  } else {
    inner = (
      <>
        <img className="rl-logo-img rl-logo--dark" src={logoBar} alt="Riffloop" style={{ height: h, width: 'auto' }} />
        <img className="rl-logo-img rl-logo--light" src={logoBarLight} alt="Riffloop" style={{ height: h, width: 'auto' }} />
      </>
    );
  }

  if (linkTo) {
    const style = { display: 'inline-flex', alignItems: 'center' } as const;
    // External URLs (the marketing site) need a real anchor, not a router Link.
    if (/^https?:\/\//.test(linkTo)) {
      return (
        <a href={linkTo} aria-label="Riffloop home" style={style}>
          {inner}
        </a>
      );
    }
    return (
      <Link to={linkTo} aria-label="Riffloop home" style={style}>
        {inner}
      </Link>
    );
  }
  return inner;
}
